<template>
  <v-card outlined>
    <div
      style="background: linear-gradient(to right, #0c2646, #2a5788); padding: 16px 20px; border-radius: 3px 3px 0 0"
    >
      <div class="d-flex align-start justify-space-between mb-3">
        <div>
          <p class="body-2 font-weight-medium white--text ma-0">
            Resumo da Campanha
          </p>
          <p
            v-if="campanha.nome_campanha"
            class="caption ma-0 mt-1"
            style="color: #bbdefb"
          >
            {{ campanha.nome_campanha }}
          </p>
        </div>
        <span
          class="caption white--text px-2"
          style="background: rgba(255,255,255,0.2); border-radius: 12px; padding-top: 2px; padding-bottom: 2px; white-space: nowrap"
        >
          {{ etapa }} / 4
        </span>
      </div>
      <div
        style="background: rgba(255,255,255,0.3); border-radius: 8px; height: 6px"
      >
        <div
          :style="{
            background: 'white',
            borderRadius: '8px',
            height: '6px',
            width: progressoWidth,
            transition: 'width 0.5s ease'
          }"
        ></div>
      </div>
    </div>

    <div
      style="display: grid; grid-template-columns: 1fr 1fr; gap: 1px; background: rgba(0,0,0,0.12)"
    >
      <div style="padding: 12px 16px; background: white">
        <p class="caption grey--text ma-0">Custo Estimado</p>
        <p class="body-2 font-weight-bold ma-0 mt-1">
          {{ custoEstimadoTotalFormatado || "—" }}
        </p>
      </div>
      <div style="padding: 12px 16px; background: white">
        <p class="caption grey--text ma-0">Metas</p>
        <p class="body-2 font-weight-bold ma-0 mt-1">
          {{
            qtdMetas > 0
              ? `${qtdMetas} cadastrada${qtdMetas > 1 ? "s" : ""}`
              : "—"
          }}
        </p>
      </div>
      <div style="padding: 12px 16px; background: white">
        <p class="caption grey--text ma-0">Período</p>
        <p class="body-2 font-weight-bold ma-0 mt-1">{{ periodoLabel }}</p>
        <template
          v-if="campanhaTipoFechamento.id_tipo_dado === 'X' && campanhaTipoFechamento.data_inicio"
        >
          <div class="d-flex justify-space-between mt-1">
            <span class="caption grey--text">Início</span>
            <span class="caption font-weight-medium">{{
              formatDateBR(campanhaTipoFechamento.data_inicio)
            }}</span>
          </div>
          <div class="d-flex justify-space-between">
            <span class="caption grey--text">Fim</span>
            <span class="caption font-weight-medium">{{
              formatDateBR(campanhaTipoFechamento.data_final)
            }}</span>
          </div>
        </template>
        <p
          v-if="
            (campanhaTipoFechamento.id_tipo_dado === 'M' ||
              campanhaTipoFechamento.id_tipo_dado === 'R') &&
              periodoMesFormatado
          "
          class="caption font-weight-medium ma-0 mt-1"
        >
          {{ periodoMesFormatado }}
        </p>
      </div>
      <div style="padding: 12px 16px; background: white">
        <p class="caption grey--text ma-0">Empresas</p>
        <p class="body-2 font-weight-bold ma-0 mt-1">
          {{
            qtdEmpresas > 0
              ? `${qtdEmpresas} selecionada${qtdEmpresas > 1 ? "s" : ""}`
              : "—"
          }}
        </p>
      </div>
    </div>

    <div
      v-if="campanha.objetivo_campanha"
      style="border-top: 1px solid rgba(0,0,0,0.12); padding: 12px 16px; background: rgba(0,0,0,0.02)"
    >
      <p
        class="caption font-weight-bold text-uppercase grey--text ma-0 mb-1"
        style="letter-spacing: 0.06em"
      >
        Objetivo
      </p>
      <p
        class="caption ma-0"
        style="white-space: pre-line"
      >
        {{ campanha.objetivo_campanha }}
      </p>
    </div>

    <div
      v-if="empresas.length > 0"
      style="border-top: 1px solid rgba(0,0,0,0.12)"
    >
      <div style="padding: 8px 16px; background: linear-gradient(to right, #0c2646, #2a5788)">
        <p
          class="caption font-weight-bold text-uppercase white--text ma-0"
          style="letter-spacing: 0.06em"
        >
          Empresas <span style="color: rgba(255,255,255,0.7)">({{ empresas.length }})</span>
        </p>
      </div>
      <div
        style="display: grid; grid-template-columns: auto 1fr 1fr; padding: 6px 16px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.08)"
      >
        <p class="caption font-weight-medium grey--text text--darken-2 ma-0 mr-3">Band.</p>
        <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Apelido</p>
        <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Empresa</p>
      </div>
      <div
        style="max-height: 140px; overflow-y: auto; border-top: 1px solid rgba(0,0,0,0.08)"
      >
        <div
          v-for="empresa in empresas"
          :key="empresa.id_empresa_campanha || empresa.cnpj"
          style="display: grid; grid-template-columns: auto 1fr 1fr; align-items: center; padding: 8px 16px; border-bottom: 1px solid rgba(0,0,0,0.06)"
        >
          <BaseSegmento :segmento="empresa.id_band" class="mr-3" />
          <span
            class="caption font-weight-medium"
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
          >
            {{ empresa.apelido }}
          </span>
          <span
            class="caption grey--text"
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
          >
            {{ formatNomeEmpresa(empresa.nome_empresa) }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="metasPorId.length > 0" style="border-top: 1px solid rgba(0,0,0,0.12)">
      <div style="padding: 8px 16px; background: linear-gradient(to right, #0c2646, #2a5788)">
        <p
          class="caption font-weight-bold text-uppercase white--text ma-0"
          style="letter-spacing: 0.06em"
        >
          Público x Meta
          <span style="color: rgba(255,255,255,0.7)">({{ metasPorId.length }})</span>
        </p>
      </div>
      <div
        style="max-height: 260px; overflow-y: auto; border-top: 1px solid rgba(0,0,0,0.08)"
      >
        <div
          v-for="meta in metasPorId"
          :key="meta.id_campanha_meta"
          style="border-bottom: 1px solid rgba(0,0,0,0.06)"
        >
          <div style="padding: 8px 16px 7px; border-left: 3px solid #2a5788; background: rgba(42,87,136,0.04)">
            <div class="d-flex align-center justify-space-between mb-1">
              <p class="body-2 font-weight-bold primary--text ma-0" style="line-height: 1.3">
                <span class="caption font-weight-bold" style="color: #2a5788">#{{ meta.id_campanha_meta }}</span>
                {{ meta.tipo_conteudo }}
                <template v-if="meta.id_tipo_conteudo == 1 && meta.indicadores">
                  <span class="caption font-weight-regular grey--text text--darken-1"> ({{ meta.indicadores }})</span>
                </template>
              </p>
              <span v-if="meta.custo_estimado > 0" style="font-size: 10px; color: #16a34a; font-weight: 600; white-space: nowrap; margin-left: 8px; flex-shrink: 0">
                {{ formatCurrency(meta.custo_estimado) }}
              </span>
            </div>
            <div class="d-flex align-center flex-wrap" style="gap: 1px 6px">
              <span class="caption"><span class="grey--text">Participantes: </span><span class="font-weight-medium">{{ meta.nParticipantes }}</span></span>
              <span class="caption grey--text text--darken-1">·</span>
              <span class="caption"><span class="grey--text">Realizado: </span><span class="font-weight-medium">{{ meta.tipo_realizado }}</span></span>
              <template v-if="meta.id_tipo_conteudo != 2">
                <span class="caption grey--text text--darken-1">·</span>
                <span class="caption"><span class="grey--text">Cálculo: </span><span class="font-weight-medium">{{ meta.tipo_calculo }}</span></span>
              </template>
              <span class="caption grey--text text--darken-1">·</span>
              <span class="caption"><span class="grey--text">Pagamento: </span><span class="font-weight-medium">{{ meta.tipo_pagamento }}</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { format, parse } from "date-fns";
import { mapGetters } from "vuex";
import campanhaService from "@/services/campanha";
import campanhas from "@/services/http/campanhaService";
import multiplicadorBonus from "@/utils/multiplicadorBonus";

export default {
  name: "ResumoCampanhaCard",

  components: {
    BaseSegmento: () => import("@/components/shared/BaseSegmento.vue")
  },

  props: {
    etapa: { type: Number, default: 1 },
    idCampanha: { type: [String, Number], default: null }
  },

  data() {
    return {
      campanha: {},
      metasLocal: [],
      empresasLocal: []
    };
  },

  computed: {
    ...mapGetters({
      metasVuex: "campanha/getMetasCadastradas",
      empresasVuex: "campanha/getEmpresasParticipantes"
    }),

    metas() {
      return this.metasVuex.length > 0 ? this.metasVuex : this.metasLocal;
    },

    empresas() {
      return this.empresasVuex.length > 0 ? this.empresasVuex : this.empresasLocal;
    },

    progressoWidth() {
      return `${((this.etapa - 1) / 3) * 100}%`;
    },

    periodoLabel() {
      const map = {
        X: "Personalizado",
        M: "Mês Referência",
        R: "Mês Fechado",
        C: "Semanal"
      };
      return map[this.campanha.id_tipo_dado] || "—";
    },

    periodoMesFormatado() {
      const c = this.campanha;
      if (!c.data_inicio || (c.id_tipo_dado !== "M" && c.id_tipo_dado !== "R")) return "";
      const date = new Date(c.data_inicio);
      const meses = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
      ];
      return `${meses[date.getMonth()]} ${date.getFullYear()}`;
    },

    campanhaTipoFechamento() {
      return {
        id_tipo_dado: this.campanha.id_tipo_dado || "",
        data_inicio: this.campanha.data_inicio || "",
        data_final: this.campanha.data_final || ""
      };
    },

    qtdEmpresas() {
      return this.empresas.length;
    },

    qtdMetas() {
      return this.metasPorId.length;
    },

    custoEstimadoTotalFormatado() {
      const total = this.metasPorId.reduce((sum, m) => sum + (m.custo_estimado || 0), 0);
      if (!total) return "";
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(total);
    },

    metasPorId() {
      const map = {};
      const indicadoresPorMeta = {};
      const participantesPorMeta = {};
      for (const row of this.metas) {
        const id = row.id_campanha_meta;
        if (!id) continue;
        if (!map[id]) {
          const tipoCalculoLabel = Number(row.id_tipo_calculo) === 2 ? "Faixa Progressiva" : "Meta Fixa";
          map[id] = {
            id_campanha_meta: id,
            id_tipo_conteudo: row.id_tipo_conteudo || null,
            tipo_realizado: row.tipo_realizado || "",
            tipo_conteudo: row.tipo_conteudo || "",
            tipo_calculo: tipoCalculoLabel,
            tipo_pagamento: row.tipo_pagamento || "",
            custo_estimado: this.calcularCustoMeta(id),
            indicadores: "",
            nParticipantes: 0
          };
          indicadoresPorMeta[id] = new Set();
          participantesPorMeta[id] = new Set();
        }
        if (row.colaborador) participantesPorMeta[id].add(row.colaborador);
        if (row.id_indicador) {
          const nome = row.indicador || `#${row.id_indicador}`;
          indicadoresPorMeta[id].add(nome);
        }
      }
      for (const id in map) {
        map[id].indicadores = [...indicadoresPorMeta[id]].join(", ");
        map[id].nParticipantes = participantesPorMeta[id].size;
      }
      return Object.values(map);
    }
  },

  watch: {
    idCampanha(val) {
      if (val) this.carregarDados();
    }
  },

  methods: {
    async carregarDados() {
      if (!this.idCampanha) return;

      try {
        const { data } = await campanhaService.getById(this.idCampanha);
        this.campanha = data;
      } catch { /* silently fail */ }

      if (this.empresasVuex.length === 0) {
        try {
          await this.$store.dispatch("campanha/actionEmpresasParticipantes", this.idCampanha);
        } catch { /* silently fail */ }
      }

      if (this.metasVuex.length === 0) {
        try {
          const res = await campanhas().metasCampanha().show({ id_campanha: this.idCampanha, per_page: -1 });
          this.metasLocal = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
        } catch { /* silently fail */ }
      }
    },

    formatDateBR(dateStr) {
      if (!dateStr) return "—";
      try {
        return format(parse(dateStr, "yyyy-MM-dd HH:mm:ss", new Date()), "dd/MM/yyyy");
      } catch {
        return dateStr;
      }
    },

    formatNomeEmpresa(nome) {
      return nome ? nome.split("-")[0].trim() : "";
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(parseFloat(value) || 0);
    },

    calcularCustoMeta(metaId) {
      const rows = this.metas.filter(r => r.id_campanha_meta == metaId);
      if (!rows.length) return 0;
      const row = rows[0];
      const tipoPagamento = Number(row.id_tipo_pagamento);
      const tipoCalculo = Number(row.id_tipo_calculo);
      const tipoConteudo = Number(row.id_tipo_conteudo);
      const colaboradores = [...new Set(rows.map(r => r.colaborador).filter(Boolean))];
      const nColaboradores = colaboradores.length || 1;

      if (tipoConteudo === 2) {
        const chassi = [...new Map(rows.filter(r => r.chassi_completo).map(r => [r.chassi_completo, r])).values()];
        return chassi.reduce((sum, r) => sum + (parseFloat(r.valor_bonus) || 0), 0);
      }
      if (tipoConteudo === 3) {
        let por = 0;
        if (tipoCalculo === 2) {
          const ids = [...new Set(rows.filter(r => r.id_produto && r.qtde_de != null).map(r => r.id_produto))];
          ids.forEach(id => {
            const faixas = rows.filter(r => r.id_produto == id && r.qtde_de != null).sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
            if (faixas.length) por += multiplicadorBonus({ tipoPagamento, quantidade: faixas[0].qtde_ate }) * (parseFloat(faixas[0].valor_bonus) || 0);
          });
        } else {
          const modelos = [...new Map(rows.filter(r => r.id_produto).map(r => [r.id_produto, r])).values()];
          modelos.forEach(r => { por += multiplicadorBonus({ tipoPagamento, quantidade: r.valor_meta }) * (parseFloat(r.valor_bonus) || 0); });
        }
        return por * nColaboradores;
      }
      if (tipoConteudo === 4) {
        let por = 0;
        if (tipoCalculo === 2) {
          const ids = [...new Set(rows.filter(r => r.id_peca && r.qtde_de != null).map(r => r.id_peca))];
          ids.forEach(id => {
            const faixas = rows.filter(r => r.id_peca == id && r.qtde_de != null).sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
            if (faixas.length) por += multiplicadorBonus({ tipoPagamento, quantidade: faixas[0].qtde_ate }) * (parseFloat(faixas[0].valor_bonus) || 0);
          });
        } else {
          const pecas = [...new Map(rows.filter(r => r.id_peca).map(r => [r.id_peca, r])).values()];
          pecas.forEach(r => { por += multiplicadorBonus({ tipoPagamento, quantidade: r.valor_meta }) * (parseFloat(r.valor_bonus) || 0); });
        }
        return por * nColaboradores;
      }
      if (tipoConteudo === 5) {
        let por = 0;
        if (tipoCalculo === 2) {
          const ids = [...new Set(rows.filter(r => r.id_servico && r.qtde_de != null).map(r => r.id_servico))];
          ids.forEach(id => {
            const faixas = rows.filter(r => r.id_servico == id && r.qtde_de != null).sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
            if (faixas.length) por += multiplicadorBonus({ tipoPagamento, quantidade: faixas[0].qtde_ate }) * (parseFloat(faixas[0].valor_bonus) || 0);
          });
        } else {
          const servicos = [...new Map(rows.filter(r => r.id_servico).map(r => [r.id_servico, r])).values()];
          servicos.forEach(r => { por += multiplicadorBonus({ tipoPagamento, quantidade: r.valor_meta }) * (parseFloat(r.valor_bonus) || 0); });
        }
        return por * nColaboradores;
      }
      const bonus = parseFloat(row.valor_bonus) || 0;
      let por = 0;
      if (tipoCalculo === 2) {
        const ids = [...new Set(rows.filter(r => r.id_indicador && r.qtde_de != null).map(r => r.id_indicador))];
        ids.forEach(id => {
          const faixas = rows.filter(r => r.id_indicador == id && r.qtde_de != null).sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
          if (faixas.length) por += multiplicadorBonus({ tipoPagamento, tipoApuracao: faixas[0].tipo_apuracao, baseCalculo: faixas[0].base_calculo_indicador, quantidade: faixas[0].qtde_ate }) * (parseFloat(faixas[0].valor_bonus) || 0);
        });
      } else if (tipoPagamento === 1) {
        // Multiplicador por INDICADOR - margem 'P' entra com zero, quantidade com a meta.
        const inds = [...new Map(rows.filter(r => r.id_indicador).map(r => [r.id_indicador, r])).values()];
        por = inds.reduce((s, r) => s + multiplicadorBonus({ tipoPagamento, tipoApuracao: r.tipo_apuracao, baseCalculo: r.base_calculo_indicador, quantidade: r.valor_meta }), 0) * bonus;
      } else {
        por = bonus;
      }
      return por * nColaboradores;
    }
  },

  mounted() {
    if (this.idCampanha) this.carregarDados();
  }
};
</script>
